export const SinkTypeEnum = {
  Restreaming: "restreaming",
  Recording: "recording",
} as const

export type SinkTypeEnum = typeof SinkTypeEnum[keyof typeof SinkTypeEnum]

export const DefaultSinkType = {
  Vindral: "vindral",
  MoQ: "moq",
} as const

export type DefaultSinkType = typeof DefaultSinkType[keyof typeof DefaultSinkType]

export const DefaultSourceType = {
  Rtmp: "rtmp",
  MoQ: "moq",
} as const

export type DefaultSourceType = typeof DefaultSourceType[keyof typeof DefaultSourceType]
